import React from "react"
import _ from "lodash"
import Isvg from 'react-inlinesvg'
import { AddIcon, DeleteIcon } from "images/icons/tools/"
import { AddRemoveRow_s } from "components/table/carousel/carousel-styles"

import automationService from "data/automation"

type Item_t = object & {
  i: number
}

interface Props {
  emptyRecord: object,
  items: Item_t[],
  row: number,
  setState: Function
}

function isRowFocused(domNode) {
  return domNode.parentElement.contains(document.activeElement)
}

class RowAddRemove extends React.Component<Props> {
  nodeRef: React.Ref<HTMLDivElement>
  automationSubscription: {unsubscribe: Function}

  constructor(props){
    super(props);
    this.nodeRef = React.createRef<HTMLDivElement>()
    this.automationSubscription = automationService.stream().subscribe(event => {
      switch(true) {
        case event.type === "HOTKEY_ADD_ROW":
          if(isRowFocused(_.get(this, "nodeRef.current"))) {
            this.addRow(null, props.row, _.get(this, "nodeRef.current").children[0])
          }
          break
        case event.type === "HOTKEY_REMOVE_ROW":
          if(isRowFocused(_.get(this, "nodeRef.current"))) {
            this.removeRow(null, props.row, _.get(this, "nodeRef.current").children[1])
          }
          break
      }
    })
  }

  componentWillUnmount() {
    this.automationSubscription.unsubscribe()
  }

  getContainer = (div) => div.classList.contains('carousel-multi-row') ? div.parentElement : this.getContainer(div.parentElement)
  getRowContainer = (div) => div.classList.contains('carousel-multi-row') ? div : this.getRowContainer(div.parentElement)

  addRow = (e:Event|null, i:number, targetDiv:Element|null) => {
    const div = targetDiv || e && e.target && e.target['closest']("div");
    const container = this.getContainer(div);
    const rowContainer = this.getRowContainer(div)
    const { emptyRecord, items, setState } = this.props;
    if (i === items.length - 1){
      items.push({...emptyRecord, i: i+1})
    } else {
      items.splice(i+1, 0, {...emptyRecord, i: i+1});
    }
    items.map((item, i) => { return item.i = i});
    setState([...items]);
    setTimeout(() => automationService.broadcast("CAROUSEL_ROW_ADD_REMOVE", {div, container, rowContainer, i, op: 'ADD'}), 200)
  }

  removeRow = (e:Event|null, i:number, targetDiv:Element|null) => {
    const div = targetDiv || e && e.target && e.target['closest']("div");
    const container = this.getContainer(div);
    const rowContainer = this.getRowContainer(div)
    const { emptyRecord, items, setState } = this.props;
    const removeIndex = items.map(item => { return item.i; }).indexOf(i);
    items.splice(removeIndex, 1);
    if (!items.length) items.push({...emptyRecord, i: 0});
    items.map((item, i) => { return item.i = i});
    setState([...items]);
    setTimeout(() => automationService.broadcast("CAROUSEL_ROW_ADD_REMOVE", {div, container, rowContainer, i, op: 'REMOVE'}), 200)
  }

  render (){
    const { row } = this.props;

    return (
      <AddRemoveRow_s ref={this.nodeRef}>
        <div className="carousel-row-add" title="Add Row">
          <Isvg src={AddIcon} onClick={(e:Event)=>this.addRow(e, row, null)} />
        </div>
        <div className="carousel-row-delete" title="Delete Row">
          <Isvg src={DeleteIcon} onClick={(e:Event)=>this.removeRow(e, row, null)} />
        </div>
      </AddRemoveRow_s>
    )
  }
}

export default RowAddRemove
